import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import { Swiper, SwiperSlide } from "swiper/react";
import rhombusFilled from "../../../static/images/general/rhombus-fill.svg";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "../../styles/components/slices/benefits.scss";
import "../../styles/components/slices/banner_boxes.scss";

const Benefits = ({ slice }) => {
  if (!slice) return null;
  const data = slice.primary;

  return (
    <Container fluid className="benefits-slice">
      <Container className="max-container">
        <Row className="py-5 justify-content-center">
          <Col md={5} className="align-self-center text-center text-md-end">
            <GatsbyImage
              image={data.image.gatsbyImageData}
              alt={data.image.alt}
              className="me-md-5"
            />
          </Col>
          <Col md={7} className="align-self-center">
            <h2 className="font-w-300 font-s-35 mt-5 mt-md-0 mb-5 mb-md-3 text-center text-md-start">
              {data.title1.text}
            </h2>
            <div className="wrap-text">
              <PrismicRichText field={data.description.richText} />
            </div>
          </Col>
        </Row>

        <div
          className={`boxes ${
            slice.primary.boxes ? "" : "d-none"
          } d-none d-md-block`}
        >
          <Row className="justify-content-center gx-4 pb-5">
            {slice.items?.map((box, index) => (
              <Col md={6} lg={3} key={index} className="mb-2 mb-lg-0">
                <div className="box d-flex align-items-center p-3">
                  <span
                    data-index={index}
                    className="w-25 me-2"
                    style={{ width: "50px" }}
                  >
                    <img src={rhombusFilled} alt="rhombus icon" />
                  </span>
                  <PrismicRichText
                    field={box.boxes_description.richText}
                    className="mb-0"
                  />
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="d-block d-md-none boxes pb-4">
          <Swiper slidesPerView="auto" spaceBetween={10} className="mySwiper">
            <Row className="justify-content-center gx-2 pb-5">
              {slice.items?.map((box, index) => (
                <SwiperSlide key={index}>
                  <Col key={index} className="mb-2 mb-lg-0">
                    <div className="box d-flex align-items-center p-3">
                      <span data-index={index} className="me-2">
                        <img
                          src={rhombusFilled}
                          alt="rhombus icon"
                          style={{ height: "20px", width: "20px" }}
                        />
                      </span>
                      <PrismicRichText
                        field={box.boxes_description.richText}
                        className="mb-0"
                      />
                    </div>
                  </Col>
                </SwiperSlide>
              ))}
            </Row>
          </Swiper>
        </div>
      </Container>
    </Container>
  );
};

export default Benefits;
